import React from 'react'
import styled from 'styled-components'
import { Button } from './button'

export const modalButtons = (type, actions) => {
  switch (type) {
    case 'success': {
      return (
        <Button
          theme='#28a745'
          // width='40px'
          // height='26px'
          width='50px'
          height='38px'
          onClick={ actions.close }
        >
          OK
        </Button>
      )
    }
    case 'error': {
      return (
        <Button
          theme='#F0C34E'
          width='80px'
          height='38px'
          onClick={ actions.close }
        >
          Try again
        </Button>
      )
    }
    case 'discard': {
      return (
        <ButtonGroup>
          <Button
            theme='#D44B49'
            width='70px'
            // height='26px'
            height='38px'
            onClick={ actions.discard }
          >
              Discard
          </Button>
          <Button
            theme='#6c757d'
            width='70px'
            // height='26px'
            height='38px'
            onClick={ actions.cancel }
          >
              Close
          </Button>
        </ButtonGroup>
      )
    }
    case 'delete': {
      return (
        <ButtonGroup>
          <Button
            theme='#D44B49'
            width='70px'
            // height='26px'
            height='38px'
            onClick={ actions.delete }
          >
              Delete
          </Button>
          <Button
            theme='#6c757d'
            width='70px'
            // height='26px'
            height='38px'
            onClick={ actions.cancel }
          >
              Close
          </Button>
        </ButtonGroup>
      )
    }
    default: return null
  }
}

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;

    div:nth-child(1) {
      margin-right: 12px;
    }
`



// WEBPACK FOOTER //
// ./src/components/buttons/modal-button.js